import { Paper } from '@mui/material';
import styled from 'styled-components';
export const InitContent = styled(Paper) `
  &&.MuiPaper-root {
    ${({ withoutshadow }) => withoutshadow === 'true' && 'box-shadow: unset;'};
  }
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
